import {
  Button,
  DatePicker,
  Form,
  FormProps,
  Radio,
  Select,
  TimePicker,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { ArrayOption, selectSearchOption } from "../../../helpers/siteConfig";
import useDebounce from "../../../hooks/useDebounce";
import {
  getAllAreaAsync,
  getAllRegionAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import {
  createTowerTicketAsync,
  towerTicketNotificationAsync,
} from "../../../store/features/NP/network/networkAPI";
import { getAllUsersAsync } from "../../../store/features/NP/resource/resourceAPI";
import { getAllSupplierAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import {
  GetAllTowerData,
  GetAllUsersParams,
  TicketGenerateData,
} from "../../../types/redux";
import { SupplierGetAllParams } from "../../../types/redux/NP/supplier";
import { capitalize } from "../../../utils/string";
import { formatDate } from "../../../utils/time";
import LocatorListItem from "../../ui/LocatorListItem";
import NetworkActionModal from "./NetworkActionModal";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
  reRender: (val: boolean) => void;
};

export default function TicketGenerate({
  open,
  handleClose,
  data,
  reRender,
}: Props) {
  const [selectedType, setSelectedType] = useState("general");
  const [supplierId, setSupplierId] = useState(undefined);
  const dispatch = useAppDispatch();
  const { keyword } = useDebounce();
  // const [selectRegion, setSelectRegion] = useState("");
  // const [selectArea, setSelectArea] = useState("");
  // const [selectTerritory, setSelectTerritory] = useState("");
  // const { regions, areas, territorys } = useAppSelector((state) => state.npGeo);
  const { allUsers } = useAppSelector((state) => state.resource);
  const { areas } = useAppSelector((state) => state.npGeo);
  const { postLoading } = useAppSelector((state) => state.network);
  const { allSupplier } = useAppSelector((state) => state.supplier);
  const { login } = useAppSelector((state) => state.login);
  const ticketData = data as GetAllTowerData;
  const [form] = Form.useForm();

  const selectedZone = Form.useWatch("zone", form);
  const selectedRegion = areas?.find((el) => el._id === selectedZone)?.region
    ?._id;
  const selectedVendor = Form.useWatch("suppler", form);

  const onFinish: FormProps<TicketGenerateData>["onFinish"] = (values) => {
    const {
      checkList,
      longitude,
      latitude,
      contactNo,
      towerName,
      _id,
      siteCode,
      region,
      regionName,
      area,
      areaName,
      teritory,
      teritoryName,
      optionalContactNo,
      address,
      radius,
      contactPersonName,
      towerType,
      easiCode,
    } = ticketData;
    const { offTime, date, ...rest } = values;
    const time = offTime as any;
    const selectDate = date as any;

    const kpi =
      values?.kpi === "both"
        ? ["robi", "gp"]
        : values?.kpi === "robi"
        ? ["robi"]
        : values?.kpi === "gp"
        ? ["gp"]
        : [];

    const pgType =
      values?.kpi === "both"
        ? "double"
        : values?.kpi === "robi"
        ? "single"
        : values?.kpi === "gp"
        ? "single"
        : [];

    const data = {
      ...rest,
      region,
      area,
      teritory,
      regionName,
      areaName,
      teritoryName,
      checkList,
      longitude,
      latitude,
      contactNo,
      towerName,
      siteCode,
      tower: _id,
      offTime: time.format("hh:mm A"),
      date: formatDate(selectDate?.format(), "DD/MM/YYYY"),
      requestList: allUsers?.map((el) => ({
        user: el?._id,
      })),
      optionalContactNo,
      address,
      radius,
      kpi,
      pgType,
      contactPersonName,
      operator: values?.kpi,
      towerType,
      easiCode,
      // towerType: selectedType === "contingency" ? towerType : undefined,
    };

    dispatch(
      createTowerTicketAsync({
        data,
        others: {
          reRender,
          successDone,
        },
      })
    );
  };

  function successDone(id: string) {
    dispatch(
      towerTicketNotificationAsync({
        data: { towerTicketId: id },
        others: null,
      })
    );
  }

  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllAreaAsync({}));
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(
  //     getAllAreaAsync({
  //       params: {
  //         region: selectRegion,
  //       },
  //     })
  //   );
  // }, [dispatch, selectRegion]);

  // useEffect(() => {
  //   dispatch(
  //     getAllTerritoryAsync({
  //       params: {
  //         area: selectArea,
  //       },
  //     })
  //   );
  // }, [dispatch, selectArea]);

  useEffect(() => {
    if (ticketData?.teritory) {
      const params: GetAllUsersParams = {
        teritory:
          selectedType === "contingency"
            ? undefined
            : `["${ticketData?.teritory}"]`,
        isPG: true,
        suppler: selectedType === "contingency" ? selectedVendor : undefined,
      };

      dispatch(
        getAllUsersAsync({
          params,
        })
      );
    }
  }, [dispatch, selectedType, selectedVendor, ticketData?.teritory]);

  const supplierData = useCallback(() => {
    const params: SupplierGetAllParams = {
      // limit: limit,
      // skip: limit * (page - 1),
    };

    const searchParams: SupplierGetAllParams = {
      supplierName: keyword,
    };

    if (
      login?.role === "region" ||
      login?.role === "finance" ||
      login?.role === "vendor"
    ) {
      params.region = login?.region;
      searchParams.region = login?.region;
    }

    dispatch(
      getAllSupplierAsync({
        params: {
          ...(keyword ? searchParams : params),
          region: selectedType === "contingency" ? selectedRegion : undefined,
        },
      })
    );
  }, [
    dispatch,
    keyword,
    login?.region,
    login?.role,
    selectedRegion,
    selectedType,
  ]);

  useEffect(() => {
    supplierData();
  }, [supplierData]);

  return (
    <NetworkActionModal
      title="Site Locator"
      locatorTitle={`${capitalize(ticketData?.towerName)} - ${
        ticketData?.regionName
      }`}
      open={open}
      handleClose={handleClose}
      locatorChildren={
        <>
          <LocatorListItem title="Site Code:">
            {ticketData?.siteCode}
          </LocatorListItem>
          {/* <LocatorListItem title="Structure Type:"></LocatorListItem> */}
          <LocatorListItem title="Location:">
            {ticketData?.towerName
              ? ticketData?.towerName
                  .split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join(" ")
              : "N/A"}
          </LocatorListItem>
          <LocatorListItem title="Region:">
            {ticketData?.regionName
              ? ticketData.regionName
                  .split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join(" ")
              : "N/A"}
          </LocatorListItem>
          <LocatorListItem title="Area:">
            {ticketData?.areaName
              ? ticketData?.areaName
                  .split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join(" ")
              : "N/A"}
          </LocatorListItem>
          <LocatorListItem title="Territory:">
            {ticketData?.teritoryName
              ? ticketData?.teritoryName
                  .split(" ")
                  .map(
                    (word) =>
                      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                  )
                  .join(" ")
              : "N/A"}
          </LocatorListItem>
          {/* <LocatorListItem title="Inactive Time:">
            {"N/A"}
            <br />
            {"N/A"}
          </LocatorListItem>
          <LocatorListItem title="Electricity Status:">
            {"N/A"}
            <br />
            {"N/A"}
          </LocatorListItem> */}
        </>
      }
    >
      <div>
        <h2 className="text-center text-header text-xl font-semibold mb-6">
          Request for an agent
        </h2>

        <Form
          className="custom-form hide_star_mark highlight_placeholder"
          layout="vertical"
          onFinish={onFinish}
          size="large"
          initialValues={{
            region: ticketData?.regionName,
            area: ticketData?.areaName,
            teritory: ticketData?.teritoryName,
          }}
          form={form}
        >
          <Form.Item name="ticketType" initialValue="general">
            <Radio.Group
              className="flex items-center gap-6"
              onChange={(e) => setSelectedType(e.target.value)}
            >
              <Radio value="general">
                <span className="text-gray-800 font-bold text-base">
                  General TT
                </span>
              </Radio>
              <Radio value="contingency">
                <span className="text-gray-800 font-bold text-base">
                  Contingency TT
                </span>
              </Radio>
            </Radio.Group>
          </Form.Item>

          {selectedType === "contingency" && (
            <>
              <Form.Item
                name="zone"
                label="Select Zone"
                rules={[{ required: true, message: "Please select zone" }]}
              >
                <Select
                  placeholder="Select zonal"
                  size="large"
                  allowClear
                  showSearch
                  filterOption={selectSearchOption}
                  options={ArrayOption(
                    [...areas].sort((a, b) =>
                      a.areaName.localeCompare(b.areaName)
                    ),
                    "areaName",
                    "_id",
                    true
                  )}
                  onChange={(val) => {
                    form.setFieldValue("suppler", undefined);
                  }}
                />
              </Form.Item>

              <Form.Item
                name="suppler"
                label="Select Vendor"
                rules={[{ required: true, message: "Please select vendor" }]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  allowClear
                  showSearch
                  filterOption={selectSearchOption}
                  options={ArrayOption(allSupplier, "supplierName", "_id")}
                  onChange={(val) => {
                    setSupplierId(val);
                  }}
                  value={supplierId}
                  disabled={!selectedRegion}
                  className="min-w-[120px]"
                  optionFilterProp="children"
                />
              </Form.Item>
            </>
          )}

          {/* {selectedType !== "contingency" && (
            <>
              <Form.Item
                name="sorOne"
                label="Standard Operating Rate (X)"
                rules={[
                  {
                    required: true,
                    message: "Please enter amount",
                  },
                  {
                    type: "number",
                    min: 0,
                    message: "Amount can't be negative",
                  },
                ]}
              >
                <InputNumber
                  className="w-full"
                  size="large"
                  placeholder="Enter amount"
                />
              </Form.Item>
              <Form.Item
                name="perMinuteCharge"
                label="Standard Operating Rate (Y)"
                rules={[
                  {
                    required: true,
                    message: "Please enter amount",
                  },
                  {
                    type: "number",
                    min: 0,
                    message: "Amount can't be negative",
                  },
                ]}
              >
                <InputNumber
                  className="w-full"
                  size="large"
                  placeholder="Enter amount"
                />
              </Form.Item>
            </>
          )} */}

          <Form.Item
            name="date"
            label="Select Date"
            rules={[
              {
                required: true,
                message: "Please select date",
              },
            ]}
            initialValue={dayjs()}
          >
            <DatePicker
              size="large"
              className="w-full"
              disabledDate={(current) =>
                current.isBefore(moment().subtract(1, "day") as any)
              }
              disabled
            />
          </Form.Item>
          <Form.Item
            name="offTime"
            label="Select Time"
            initialValue={dayjs()}
            rules={[
              {
                required: true,
                message: "Please select time",
              },
            ]}
          >
            <TimePicker
              size="large"
              className="w-full"
              placeholder="HH:MM"
              format={"HH:mm"}
              disabled
            />
          </Form.Item>

          <Form.Item
            label="Select KPI"
            name="kpi"
            rules={[
              {
                required: true,
                message: "Please select KPI",
              },
            ]}
            className="col-span-6"
          >
            <Select
              placeholder="Select KPI"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={ArrayOption(phaseList, "name", "value")}
            />
          </Form.Item>

          {/* <Form.Item
            label={<span className="font-medium text-gray-700">PG Type:</span>}
            name="pgType"
            rules={[{ required: true, message: "Please select a pg type" }]}
            className="flex items-center gap-3"
          >
            <Radio.Group className="flex items-center gap-6">
              <Radio value="single">
                <span className="text-gray-800 font-medium">Single</span>
              </Radio>
              <Radio value="double">
                <span className="text-gray-800 font-medium">Double</span>
              </Radio>
            </Radio.Group>
          </Form.Item> */}

          <Button
            className="mt-2"
            type="primary"
            size="large"
            htmlType="submit"
            block
            loading={postLoading}
          >
            Next
          </Button>
        </Form>
      </div>
    </NetworkActionModal>
  );
}

export const phaseList = [
  {
    name: "Robi",
    value: "robi",
  },
  // {
  //   name: "Airtel",
  //   value: "rirtel",
  // },
  {
    name: "Grameenphone",
    value: "gp",
  },
  {
    name: "Both",
    value: "both",
  },

  // {
  //   name: "Banglalink",
  //   value: "banglalink",
  // },
  // {
  //   name: "Teletalk",
  //   value: "teletalk",
  // },
];
